export default Object.freeze({
    Regular: 'Regular',
    Desktop: 'Desktop',
    Mobile: 'Mobile',
});
